import React from 'react';
import useStyles from '../style';
import { incompatibleMessage } from '../../constants/Constants';

const Incompatible = () => {
  const classes = useStyles();
  return <div className={classes.incompatible}>{incompatibleMessage}</div>;
};

export default Incompatible;
